module.exports = __webpack_public_path__ + "static/img/边框6.5b6bdbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框6.svg
// module id = +f6T
// module chunks = 2